const axios = require('axios');

(() => {
  const cancelEventReservationButton = '.exec-event-reservation-cancel-button'
  const cancelBarbecueReservationButton = '.exec-barbecue-reservation-cancel-button'
  const cancelGroupOfCampingReservationButton = '.exec-group-of-camping-reservation-cancel-button'
  const cancelDayCampingReservationButton = '.exec-day-camping-reservation-cancel-button'

  const init = () => {
    $('body').on('click', cancelEventReservationButton, cancelEventReservation);
    $('body').on('click', cancelBarbecueReservationButton, cancelBarbecueReservation);
    $('body').on('click', cancelGroupOfCampingReservationButton, cancelGroupOfCampingReservation);
    $('body').on('click', cancelDayCampingReservationButton, cancelDayCampingReservation);
  }

  const cancelEventReservation = e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const reservationId = $element[0].id;
    const targetUrl = process.env.JS_BASE_URL + 'customer/mypage/event/reservation_cancels/' + reservationId;
    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
    axios.put(targetUrl).then(response => {
      if (response.status === 200) {
        location.href = targetUrl;
      }
    }).catch(error => {
      console.log(error);
      if (error.response.data.type == 'CancelCreditError' || error.response.data.type.includes('Classification can not be executed')) {
        alert('予約時に使用されたクレジットカードが現在利用できない状態となっているため、キャンセル処理をすることができません。お電話またはメールにてご連絡ください。\n電話番号 043-235-8376\nメール info@ushinohiroba.com');
      } else {
        alert('キャンセルに失敗しました');
      }
    })
  }

  const cancelBarbecueReservation = e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const reservationId = $element[0].id;
    const targetUrl = process.env.JS_BASE_URL + 'customer/mypage/barbecue/reservation_cancels/' + reservationId;
    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
    axios.put(targetUrl).then(response => {
      if (response.status === 200) {
        location.href = targetUrl;
      }
    }).catch(error => {
      console.log(error);
      if (error.response.data.type == 'CancelCreditError' || error.response.data.type.includes('Classification can not be executed')) {
        alert('予約時に使用されたクレジットカードが現在利用できない状態となっているため、キャンセル処理をすることができません。お電話またはメールにてご連絡ください。\n電話番号 043-235-8376\nメール info@ushinohiroba.com');
        console.log(error.response);
      } else {
        alert('キャンセルに失敗しました');
      }
    })
  }

  const cancelGroupOfCampingReservation = e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const reservationId = $element[0].id;
    const targetUrl = process.env.JS_BASE_URL + 'customer/mypage/camping/reservation_cancels/' + reservationId;
    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
    axios.put(targetUrl).then(response => {
      if (response.status === 200) {
        location.href = targetUrl;
      }
    }).catch(error => {
      console.log(error);
      if (error.response.data.type == 'CancelCreditError' || error.response.data.type.includes('Classification can not be executed')) {
        alert('予約時に使用されたクレジットカードが現在利用できない状態となっているため、キャンセル処理をすることができません。お電話またはメールにてご連絡ください。\n電話番号 043-235-8376\nメール info@ushinohiroba.com');
      } else {
        alert('キャンセルに失敗しました');
      }
    })
  }

  const cancelDayCampingReservation = e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const reservationId = $element[0].id;
    const targetUrl = process.env.JS_BASE_URL + 'customer/mypage/day_camping/reservation_cancels/' + reservationId;
    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
    axios.put(targetUrl).then(response => {
      if (response.status === 200) {
        location.href = targetUrl;
      }
    }).catch(error => {
      console.log(error);
      if (error.response.data.type == 'CancelCreditError' || error.response.data.type.includes('Classification can not be executed')) {
        alert('予約時に使用されたクレジットカードが現在利用できない状態となっているため、キャンセル処理をすることができません。お電話またはメールにてご連絡ください。\n電話番号 043-235-8376\nメール info@ushinohiroba.com');
      } else {
        alert('キャンセルに失敗しました');
      }
    })
  }
  $(init);
})();

